import { IMedia, ITourComponent, TourComponent } from './TourComponent';
import { connect } from 'react-redux';
import { IState } from '../../store';
import { compose, isEmpty, pathOr } from 'ramda';
import { withEmptyRendering } from '../../utils/hoc';

export function mapStateToProps(state: IState): ITourComponent {
  const { tour } = state.offerData;

  return {
    anchors: pathOr([], ['excursion', 'anchors'], tour),
    media: pathOr([], ['excursion', 'media'], tour),
    allPhotos: pathOr({}, ['excursion', 'allPhotos'], tour) as IMedia,
  };
}

export const shouldHideTour = (props: ITourComponent) => {
  return isEmpty(props.anchors) && isEmpty(props.media) && isEmpty(props.allPhotos);
};

export const TourContainer = compose(
  connect<ITourComponent>(mapStateToProps),
  withEmptyRendering(shouldHideTour),
)(TourComponent);
